/**
 * Admin Dashboard Page for v0.7.0
 * Management dashboard with statistics and trend charts
 * [UPDATED v0.7.2] Added DashboardTrends component
 */

import DesktopLayout from '../../../components/layout/DesktopLayout';
import DashboardStats from '../../../components/admin/DashboardStats';
import DashboardTrends from '../../../components/admin/DashboardTrends';
import './index.css';

const AdminDashboardPage = () => {
  return (
    <div className="admin-dashboard-page">
      <DesktopLayout>
      <main className="admin-dashboard-page__main">
        <div className="admin-dashboard-page__container">
          <header className="admin-dashboard-page__header">
            <h1 className="admin-dashboard-page__title">管理後台</h1>
            <p className="admin-dashboard-page__subtitle">系統營運數據概覽</p>
          </header>
          <DashboardStats />
          <DashboardTrends days={30} />
        </div>
      </main>
      </DesktopLayout>
    </div>
  );
};

export default AdminDashboardPage;
